export class UserLanguagePreferenceRequest {
    // public UserId: string = '';
    // public Password: string = '';
    // public UserToken: string = '';
    // public readonly AppType: string = 'Admin';
    // LanguagePreference: number = 0;
    
    public from_language : number = 0;
    public asha_employee_record_id : number = 0;
}
